/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "0.0.1",
  "gitBuildTime": "2025-05-26T20:04:25.429Z",
  "gitBuildVersion": "0.0.1",
  "gitCommitId": "8154cba",
  "gitCommitIdFull": "8154cbaa513e23eff04088662c5432319ab07ec7",
  "gitCommitTime": "2025-05-26T19:58:37.000Z",
  "version": "0.0.1-2025-05-26T19:58:37.000Z-(8154cba)"
};
